import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_USER_GROUP_PRICING = createActionTypes('FETCH_USER_GROUP_PRICING');
export const CREATE_USER_GROUP_PRICING = createActionTypes('CREATE_USER_GROUP_PRICING');
export const DELETE_USER_GROUP_PRICING = createActionTypes('DELETE_USER_GROUP_PRICING');
export const UPDATE_USER_GROUP_PRICING = createActionTypes('UPDATE_USER_GROUP_PRICING');
export const GET_USER_GROUP_PRICING = createActionTypes('GET_USER_GROUP_PRICING');
